// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"style-module__gradient-bg5__LUwS5","container":"style-module__container__nes7o"};